import { dashboardConstants } from "../../../../NRP/constants/dashboardConstants";
const initialState = {};

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case dashboardConstants.LOADING_REQUEST:
      return {
        campaigns: state.campaigns,
      };
    case dashboardConstants.LOAD_CAMPAIGNS:
      return {
        campaigns: action.payload.campaigns,
        defaultCampaign: action.payload.defaultCampaign,
      };
    case dashboardConstants.LOAD_CAMPAIGN_ACTIVITY_DATA:
      return {
        ...state,
        series: action.payload.series,
        categories: action.payload.categories,
      };

    case dashboardConstants.LOAD_CAMPAIGN_COUNT:
      return {
        ...state,
        campaignCountsData: action.payload.campaignCountsData,
      };

    case dashboardConstants.LOAD_CAMPAIGN_PIE_DATA:
      return {
        ...state,
        pieChartData: action.payload.pieChartData,
      };

    case dashboardConstants.LOAD_COMPETENCIES_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        assessmentData: action.payload.assessmentData,
      };

    default:
      return state;
  }
}
